'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isString = require('is-string');

var _isString2 = _interopRequireDefault(_isString);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  if (!(0, _isString2.default)(value)) return '';
  var numbers = value.replace(/\D+/g, '');
  return numbers.slice(0, 3) + '-' + numbers.slice(3, 6) + '-' + numbers.slice(6, 10);
};

var validate = function validate(value) {
  return /^\d{3}-\d{3}-\d{4}$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'string',
  format: format,
  validate: validate
});